export const ToggleLetters = (string: string) => string.replace(/(^\w{1})|(\s+\w{1})/g, letra => letra.toUpperCase());
